import TermItemSelect from './TermItemSelect';
import React from 'react';
import { useFormContainerContext } from '../../../Services/FormContainerContext';
import { FieldError, useController, useFormContext } from 'react-hook-form';

interface Props {
	name: string;
	label?: string;
	termType: string;
	error?: FieldError;
	useValue?: boolean;
	placeholder?: string;
}

const TermItemSelectField: React.FC<Props> = ({
	name,
	label,
	termType,
	error: err,
	useValue = false,
	placeholder,
}) => {
	const { name: formContainerName } = useFormContainerContext();
	const finalName = formContainerName ? `${formContainerName}.${name}` : name;

	const { control } = useFormContext();
	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: finalName || '',
	});

	return (
		<TermItemSelect
			termType={termType}
			error={err}
			useValue={useValue}
			placeholder={placeholder}
			{...field}
		/>
	);
};

export default TermItemSelectField;
